<template>
  <div class="p-4 space-y-3">
    <Skeleton width="5rem" class="mb-2" />
    <Skeleton height="4rem" width="10rem" />

    <div class="flex gap-4">
      <div class="flex flex-col gap-2">
        <Skeleton width="10rem" />
        <Skeleton width="5rem" />
        <Skeleton height="2.5rem" />
      </div>
    </div>

    <Skeleton width="10rem" />
    <Skeleton width="5rem" />
    <Skeleton width="10rem" />

    <div class="p-4 border border-dashed rounded-md">
      <div class="flex gap-4">
        <div class="flex flex-col gap-2">
          <Skeleton width="10rem" />
          <Skeleton width="5rem" />
          <Skeleton height="2.5rem" />
        </div>
      </div>

      <Skeleton height="150px" width="100%" class="my-3" />

      <div class="flex justify-center gap-3">
        <Skeleton height="2rem" width="4rem" />
        <Skeleton height="2rem" width="4rem" />
      </div>

      <div class="flex justify-center gap-3 mt-2">
        <Skeleton height="2rem" width="4rem" />
        <Skeleton height="2rem" width="4rem" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmItemSkeleton',
}
</script>
